export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8076.7692bd05.jpg";